import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const StarEmpty = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="empty star icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.93066 20.4967L8.93235 14.2631L3.65345 10.291L10.1256 10.3323L12.002 4.16558L13.8785 10.3323L20.3507 10.291L15.0718 14.2631L17.0746 20.5002L11.9955 16.5994L6.93066 20.4967ZM17.7243 23.521L11.9966 19.1221L6.27981 23.521C5.60979 24.03 5.04784 24.1543 4.60476 23.7924C4.16167 23.4419 4.06441 22.8652 4.33458 22.0397L6.59322 15.006L0.822359 10.6636C0.152335 10.1661 -0.128643 9.64589 0.0550729 9.08048C0.227982 8.53769 0.735904 8.26629 1.56803 8.2776L8.64652 8.32283L10.7971 1.25521C11.0564 0.418402 11.4455 0 11.9966 0C12.5586 0 12.9476 0.418402 13.207 1.25521L15.3575 8.32283L22.4361 8.2776C23.2682 8.26629 23.7762 8.53769 23.9491 9.08048C24.122 9.64589 23.8517 10.1661 23.1818 10.6636L17.4109 15.006L19.6695 22.0397C19.9397 22.8652 19.8424 23.4419 19.3993 23.7924C18.9455 24.1543 18.3943 24.03 17.7243 23.521Z"
    />
  </svg>
)
